import React from "react";
import { TextField } from "components";
import { usePropertyContext } from "../../context";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import ButtonV2 from "elements/ButtonV2";

const DriversLicenseNumbeShared = ({
	variant,
}: {
	variant: "first-entry" | "second-entry";
}) => {
	const { details } = usePropertyContext();
	const {
		flowId,
		next,
		additionalOwnerFirstNameValue,
		additionalOwnerLastNameValue,
		owner1DlNumberValue,
		setOwner1DlNumberValue,
		owner2DlNumberValue,
		setOwner2DlNumberValue,
	} = useExemptionsContext();
	const trackEvent = useEventTracker();

	const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
		const { value } = event.target;

		if (variant === "first-entry") {
			setOwner1DlNumberValue(value);
		}

		if (variant === "second-entry") {
			setOwner2DlNumberValue(value);
		}
	};

	const handleSubmit = async () => {
		if (variant === "first-entry") {
			trackEvent({
				eventName:
					constants.EVENTS.Exemptions_Flow_DRIVERS_LICENSE_NUMBER_Answer,
				data: {
					"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
						? "Yes"
						: "No",
				},
			});
		}

		if (variant === "second-entry") {
			trackEvent({
				eventName:
					constants.EVENTS.Exemptions_Flow_DRIVERS_LICENSE_NUMBER2_Answer,
				data: {
					"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
						? "Yes"
						: "No",
				},
			});
		}
		const trackingEventData = {
			variant,
		};
		next({ trackingEventData });
	};

	const value = React.useMemo(() => {
		if (variant === "first-entry") {
			return owner1DlNumberValue;
		}

		if (variant === "second-entry") {
			return owner2DlNumberValue;
		}
	}, [owner1DlNumberValue, owner2DlNumberValue]);

	const title = React.useMemo(() => {
		if (flowId === "GEORGIA_EXEMPTION") {
			if (variant === "first-entry") {
				return "What is your driver's license number?";
			}
			if (variant === "second-entry") {
				return `What is ${additionalOwnerFirstNameValue} ${additionalOwnerLastNameValue}'s driver's license number?`;
			}
		}
	}, [flowId, variant]);

	const subtitle =
		"Counties will require driver’s licenses number to be provided as proof of ownership.";
	const inputLabel = "Driver's License Number";

	const validationProps = React.useMemo(() => {
		// GEORGIA_EXEMPTION
		return {
			maxLength: 9,
			minLength: 9,
			numeric: true,
		};
	}, [flowId]);

	const buttonDisabled = React.useMemo(() => {
		const valueToUse =
			variant === "first-entry" ? owner1DlNumberValue : owner2DlNumberValue;
		if (!valueToUse) {
			return true;
		}

		return valueToUse.length < validationProps.minLength;
	}, [validationProps, owner1DlNumberValue, owner2DlNumberValue]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>{title}</p>
				</div>
				<p className="exemption-question-card-subtitle sm">{subtitle}</p>
				<TextField
					required
					label={inputLabel}
					placeholder="*********"
					containerClassName="exemptions-card-input"
					{...validationProps}
					autoComplete="off"
					value={value ?? ""}
					onChange={handleChange}
				/>
			</div>
			<ButtonV2 size="large" disabled={buttonDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export const DriversLicenseNumber = () => (
	<DriversLicenseNumbeShared variant="first-entry" />
);
export const DriversLicenseNumber2 = () => (
	<DriversLicenseNumbeShared variant="second-entry" />
);
